// AUTO-GENERATED by scripts/gen-schema.mjs — do not edit by hand.
// Regenerate: node --import tsx scripts/gen-schema.mjs
// Source of truth: test/fixtures/corpus-schema-data.json + python-properties.json.

/** A detected language or country, as guessit renders it. */
export interface GuessitLanguage {
  name?: string;
  alpha3?: string;
  alpha2?: string;
  country?: string | null;
  script?: string | null;
}

/** Machine-readable description of every property guessit-js can emit. */
export interface PropertySchema {
  /** JSON-ish base type(s) of the value. */
  type: Array<'string' | 'number' | 'boolean' | 'Language' | 'object'>;
  /** True if this property can be emitted as an array (multiple values). */
  array: boolean;
  /** True if this property can be emitted as a single scalar. */
  scalar: boolean;
  /** Closed vocabulary of allowed values, when the property is value-constrained. */
  enum?: Array<string | number>;
}

export const GUESSIT_SCHEMA: Record<string, PropertySchema> = {
  "absolute_episode": {
    "type": [
      "number"
    ],
    "array": true,
    "scalar": true
  },
  "alternative_title": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true
  },
  "another": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": false
  },
  "aspect_ratio": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "audio_bit_rate": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "audio_channels": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "1.0",
      "1ch",
      "2.0",
      "20",
      "2ch",
      "5.1",
      "5ch",
      "6ch",
      "7.1",
      "7ch",
      "8ch",
      "mono",
      "stereo"
    ]
  },
  "audio_codec": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "AAC",
      "Atmos",
      "DD+",
      "DDP",
      "Dolby",
      "Dolby Atmos",
      "Dolby Digital",
      "Dolby Digital Plus",
      "Dolby TrueHD",
      "DolbyDigital",
      "DTS",
      "DTS-HD",
      "DTS-X",
      "DTS:X",
      "DTSX",
      "Flac",
      "FLAC",
      "LAME",
      "LPCM",
      "MP2",
      "MP3",
      "Opus",
      "PCM",
      "Vorbis"
    ]
  },
  "audio_profile": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "ES",
      "EX",
      "Extended Surround",
      "HE",
      "High Efficiency",
      "High Quality",
      "High Resolution Audio",
      "HQ",
      "HR",
      "HRA",
      "LC",
      "Low Complexity",
      "MA",
      "Master Audio"
    ]
  },
  "bonus": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "bonus_title": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "cd": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "cd_count": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "color_depth": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "10-bit",
      "12-bit",
      "8-bit"
    ]
  },
  "container": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "3g2",
      "3gp",
      "3gp2",
      "7z",
      "ace",
      "arj",
      "asf",
      "avi",
      "bmp",
      "bz2",
      "cb7",
      "cbr",
      "cbz",
      "divx",
      "flv",
      "gif",
      "gz",
      "idx",
      "iso",
      "jpeg",
      "jpg",
      "m2ts",
      "m4v",
      "mk2",
      "mk3d",
      "mka",
      "mkv",
      "MKV",
      "mov",
      "mp4",
      "mp4a",
      "mpeg",
      "mpg",
      "nfo",
      "nzb",
      "ogg",
      "ogm",
      "ogv",
      "png",
      "qt",
      "r00",
      "ra",
      "ram",
      "rar",
      "rm",
      "srt",
      "ssa",
      "tar",
      "tbn",
      "tgz",
      "torrent",
      "ts",
      "vob",
      "wav",
      "webm",
      "webp",
      "wma",
      "wmv",
      "zip"
    ]
  },
  "country": {
    "type": [
      "Language"
    ],
    "array": false,
    "scalar": true
  },
  "crc32": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "date": {
    "type": [
      "object"
    ],
    "array": false,
    "scalar": true
  },
  "disc": {
    "type": [
      "number"
    ],
    "array": true,
    "scalar": true
  },
  "edition": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "Alternative Cut",
      "CC",
      "collector",
      "Collector",
      "Criterion",
      "DC",
      "ddc",
      "deluxe",
      "Deluxe",
      "Director's Cut",
      "Director's Definitive Cut",
      "extended",
      "Extended",
      "Fan",
      "Festival",
      "imax",
      "IMAX",
      "limited",
      "Limited",
      "Remastered",
      "Restored",
      "se",
      "Special",
      "theatrical",
      "Theatrical",
      "Ultimate",
      "Uncensored",
      "Uncut",
      "Unrated"
    ]
  },
  "episode": {
    "type": [
      "number"
    ],
    "array": true,
    "scalar": true
  },
  "episode_count": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "episode_details": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true
  },
  "episode_format": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "Minisode"
    ]
  },
  "episode_title": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "film": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "film_title": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "frame_rate": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "language": {
    "type": [
      "Language"
    ],
    "array": true,
    "scalar": true
  },
  "mimetype": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "application/x-bittorrent",
      "application/x-iso9660-image",
      "application/x-rar-compressed",
      "application/zip",
      "image/gif",
      "image/jpeg",
      "image/png",
      "text/plain",
      "video/mp2t",
      "video/mp4",
      "video/webm",
      "video/x-matroska",
      "video/x-msvideo"
    ]
  },
  "other": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "2in1",
      "3D",
      "asrequested",
      "Audio Fixed",
      "Banner",
      "Bonus",
      "BT.2020",
      "Classic",
      "Clear Art",
      "Clear Logo",
      "Colorized",
      "Complet",
      "Complete",
      "CONVERT",
      "Converted",
      "Cover",
      "Dirfix",
      "Disc Art",
      "DOCU",
      "Documentary",
      "DOKU",
      "Dolby Vision",
      "Dual",
      "Dual Audio",
      "East Coast Feed",
      "Extras",
      "Fan Subtitled",
      "Fanart",
      "Fansub",
      "Fast Subtitled",
      "Fastsub",
      "FHD",
      "Fix",
      "Fixed",
      "Full HD",
      "Half Over Under",
      "Half Side By Side",
      "Hardcoded Subtitles",
      "HC",
      "HD",
      "HDLight",
      "HDR10",
      "HFR",
      "High Frame Rate",
      "High Quality",
      "High Resolution",
      "HQ",
      "HR",
      "Hybrid",
      "Internal",
      "Landscape",
      "LD",
      "LDTV",
      "LiNE",
      "Line Audio",
      "Line Dubbed",
      "Logo",
      "Low Definition",
      "MD",
      "mHD",
      "Mic Dubbed",
      "Micro HD",
      "Mux",
      "Nfofix",
      "NTSC",
      "Oad",
      "OAR",
      "Oav",
      "Obfuscated",
      "Ona",
      "Open Matte",
      "Original Animated Video",
      "Original Animation DVD",
      "Original Aspect Ratio",
      "Original Net Animation",
      "Original Video",
      "OV",
      "Ova",
      "Over Under",
      "PAL",
      "postbot",
      "Poster",
      "Preair",
      "Proof",
      "Prooffix",
      "Proper",
      "PS Vita",
      "R5",
      "RC",
      "Read NFO",
      "Real",
      "Reencoded",
      "Region 5",
      "Region C",
      "Remux",
      "Repost",
      "Retail",
      "Rip",
      "Sample",
      "Scrambled",
      "Screener",
      "SDR",
      "SECAM",
      "Side By Side",
      "Standard Dynamic Range",
      "Straight to Video",
      "STV",
      "Sync Fixed",
      "Thumbnail",
      "Trailer",
      "UHD",
      "Ultra HD",
      "Upscaled",
      "Variable Frame Rate",
      "VFR",
      "Virtual Reality",
      "Vita",
      "VO",
      "vost",
      "West Coast Feed",
      "Widescreen",
      "ws",
      "xpost",
      "XXX"
    ]
  },
  "part": {
    "type": [
      "number"
    ],
    "array": true,
    "scalar": true
  },
  "proper_count": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "release_group": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "screen_size": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "1080i",
      "1080p",
      "1440p",
      "1444x866",
      "2160p",
      "360p",
      "368p",
      "480p",
      "4k",
      "540p",
      "576p",
      "720p",
      "720x432",
      "960x544"
    ]
  },
  "season": {
    "type": [
      "number"
    ],
    "array": true,
    "scalar": true
  },
  "season_count": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "size": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "source": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "Analog HDTV",
      "Blu-ray",
      "Camera",
      "Digital Master",
      "Digital TV",
      "DVD",
      "HD Camera",
      "HD Telecine",
      "HD Telesync",
      "HD-DVD",
      "HDTV",
      "Laserdisc",
      "Pay-per-view",
      "Satellite",
      "Telecine",
      "Telesync",
      "TV",
      "Ultra HD Blu-ray",
      "Ultra HDTV",
      "VHS",
      "Video on Demand",
      "Web",
      "Workprint"
    ]
  },
  "streaming_service": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "4OD",
      "9Now",
      "9NOW",
      "A&E",
      "ABC",
      "ABC Australia",
      "Adult Swim",
      "AE",
      "AJAZ",
      "Al Jazeera English",
      "ALL4",
      "Amazon",
      "Amazon Prime",
      "AMBC",
      "AMC",
      "America's Test Kitchen",
      "AMZN",
      "AMZN-CBR",
      "Animal Planet",
      "AnimeLab",
      "ANLB",
      "ANPL",
      "AOL",
      "AppleTV",
      "APTV",
      "ARD",
      "AS",
      "ATK",
      "ATV+",
      "ATVP",
      "AUBC",
      "BBC iPlayer",
      "Binge",
      "BKPL",
      "Blackpills",
      "BLU",
      "BluTV",
      "BNGE",
      "BOOM",
      "Boomerang",
      "BRAV",
      "BravoTV",
      "Canal+",
      "Cartoon Network",
      "CBC",
      "CBS",
      "CC",
      "CCGC",
      "Channel 4",
      "CHGD",
      "CHRGD",
      "Cinemax",
      "CMAX",
      "CMT",
      "CN",
      "CNBC",
      "CNLP",
      "Comedians in Cars Getting Coffee",
      "Comedy Central",
      "Country Music Television",
      "CR",
      "Crackle",
      "CRAV",
      "Crave",
      "CRKL",
      "Crunchy Roll",
      "CSpan",
      "CSPN",
      "CTV",
      "CUR",
      "CuriosityStream",
      "CW",
      "CWS",
      "CWSeed",
      "Daisuki",
      "DC Universe",
      "DCU",
      "DDY",
      "Deadhouse Films",
      "DF",
      "DHF",
      "Digiturk Diledigin Yerde",
      "DISC",
      "Discovery",
      "Discovery Plus",
      "Disney",
      "Disney+",
      "DIY",
      "DIY Network",
      "Doc Club",
      "DOCC",
      "DPlay",
      "DPLY",
      "DramaFever",
      "DSCP",
      "DSKI",
      "DSNP",
      "DSNY",
      "E!",
      "El Trece",
      "ePix",
      "EPIX",
      "ESPN",
      "ESQ",
      "Esquire",
      "ETTV",
      "ETV",
      "Facebook Watch",
      "FAM",
      "Family",
      "Family Jr",
      "Fandor",
      "FANDOR",
      "FBWatch",
      "FJR",
      "FOOD",
      "Food Network",
      "Fox",
      "FOX",
      "Fox Premium",
      "FOXP",
      "Foxtel",
      "FP",
      "FREE",
      "Freeform",
      "FXTL",
      "FYI",
      "FYI Network",
      "Gaga",
      "GagaOOLala",
      "GC",
      "GLBL",
      "GLOB",
      "Global",
      "GloboSat Play",
      "Hallmark",
      "HBO",
      "HBO Go",
      "HBO Max",
      "HGTV",
      "HIST",
      "History",
      "HLMK",
      "HMAX",
      "hoichoi",
      "HoiChoi",
      "Hulu",
      "HULU",
      "ID",
      "IFC",
      "iflix",
      "IFX",
      "INA",
      "Investigation Discovery",
      "iP",
      "iQIYI",
      "iT",
      "iTunes",
      "ITV",
      "KNOW",
      "Knowledge Network",
      "LIFE",
      "Lifetime",
      "MBC",
      "MBCVOD",
      "MNBC",
      "Motor Trend OnDemand",
      "MSNBC",
      "MTOD",
      "MTV",
      "MUBI",
      "NATG",
      "National Audiovisual Institute",
      "National Film Board",
      "National Geographic",
      "NBA",
      "NBA TV",
      "NBC",
      "Netflix",
      "NF",
      "NFB",
      "NFL",
      "NFL Now",
      "NFLN",
      "NHL GameCenter",
      "NICK",
      "NICKAPP",
      "Nickelodeon",
      "Norsk Rikskringkasting",
      "NRK",
      "ODK",
      "OnDemandKorea",
      "Oprah Winfrey Network",
      "Opto",
      "OPTO",
      "OWN",
      "Paramount+",
      "ParamountPlus",
      "PBS",
      "PBS Kids",
      "PBSK",
      "PCOK",
      "Peacock",
      "Playstation Network",
      "PLUZ",
      "Pluzz",
      "PMNP",
      "PMT+",
      "PMTP",
      "POGO",
      "PokerGO",
      "PSN",
      "Rakuten TV",
      "RED",
      "RKTN",
      "ROKU",
      "RTE",
      "RTE One",
      "RUUTU",
      "SBS",
      "SCI",
      "Science Channel",
      "SeeSo",
      "SESO",
      "SHMI",
      "SHO",
      "Shomi",
      "Showtime",
      "SNET",
      "Sony",
      "SONY",
      "SPIK",
      "Spike",
      "Spike TV",
      "SPKE",
      "Sportsnet",
      "Sprout",
      "SPRT",
      "Stan",
      "STAN",
      "Starz",
      "STZ",
      "Sveriges Television",
      "SVT",
      "SwearNet",
      "SWER",
      "Syfy",
      "SYFY",
      "TBS",
      "TFou",
      "TFOU",
      "The CW",
      "The Roku Channel",
      "TLC",
      "TUBI",
      "TubiTV",
      "TV Land",
      "TV3",
      "TV3 Ireland",
      "TV4",
      "TV4 Sweeden",
      "TVING",
      "TVL",
      "TVNZ",
      "UFC",
      "UFC Fight Pass",
      "UKTV",
      "UNIV",
      "Univision",
      "USA Network",
      "USAN",
      "Velocity",
      "VH1",
      "VICE",
      "Viceland",
      "Viki",
      "VIKI",
      "Vimeo",
      "VLCT",
      "VMEO",
      "VRV",
      "W Network",
      "WatchMe",
      "WME",
      "WNET",
      "WWE Network",
      "WWEN",
      "XBOX",
      "Xbox Video",
      "Yahoo",
      "YHOO",
      "YouTube Red",
      "ZDF"
    ]
  },
  "subtitle_language": {
    "type": [
      "Language"
    ],
    "array": true,
    "scalar": true
  },
  "title": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "type": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "episode",
      "movie"
    ]
  },
  "uuid": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "version": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  },
  "video_api": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "DXVA"
    ]
  },
  "video_bit_rate": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "video_codec": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true,
    "enum": [
      "DivX",
      "DVDivX",
      "H.263",
      "H.264",
      "H.265",
      "MPEG-2",
      "RealVideo",
      "VC-1",
      "VP7",
      "VP8",
      "VP80",
      "VP9",
      "Xvid",
      "XviD"
    ]
  },
  "video_profile": {
    "type": [
      "string"
    ],
    "array": true,
    "scalar": true,
    "enum": [
      "Advanced Video Codec High Definition",
      "Baseline",
      "BP",
      "EP",
      "Extended",
      "HEVC",
      "High",
      "High 10",
      "High 4:2:2",
      "High 4:4:4 Predictive",
      "High Efficiency Video Coding",
      "HiP",
      "HP",
      "Main",
      "MP",
      "SC",
      "Scalable Video Coding",
      "SVC",
      "XP"
    ]
  },
  "website": {
    "type": [
      "string"
    ],
    "array": false,
    "scalar": true
  },
  "year": {
    "type": [
      "number"
    ],
    "array": false,
    "scalar": true
  }
};

/** Fully-typed guessit-js result. Every key is optional (presence depends on the input). */
export interface GuessItResult {
  absolute_episode?: number | (number)[];
  alternative_title?: string | (string)[];
  another?: string;
  aspect_ratio?: number;
  audio_bit_rate?: string;
  audio_channels?: "1.0" | "1ch" | "2.0" | "20" | "2ch" | "5.1" | "5ch" | "6ch" | "7.1" | "7ch" | "8ch" | "mono" | "stereo" | ("1.0" | "1ch" | "2.0" | "20" | "2ch" | "5.1" | "5ch" | "6ch" | "7.1" | "7ch" | "8ch" | "mono" | "stereo")[];
  audio_codec?: "AAC" | "Atmos" | "DD+" | "DDP" | "Dolby" | "Dolby Atmos" | "Dolby Digital" | "Dolby Digital Plus" | "Dolby TrueHD" | "DolbyDigital" | "DTS" | "DTS-HD" | "DTS-X" | "DTS:X" | "DTSX" | "Flac" | "FLAC" | "LAME" | "LPCM" | "MP2" | "MP3" | "Opus" | "PCM" | "Vorbis" | ("AAC" | "Atmos" | "DD+" | "DDP" | "Dolby" | "Dolby Atmos" | "Dolby Digital" | "Dolby Digital Plus" | "Dolby TrueHD" | "DolbyDigital" | "DTS" | "DTS-HD" | "DTS-X" | "DTS:X" | "DTSX" | "Flac" | "FLAC" | "LAME" | "LPCM" | "MP2" | "MP3" | "Opus" | "PCM" | "Vorbis")[];
  audio_profile?: "ES" | "EX" | "Extended Surround" | "HE" | "High Efficiency" | "High Quality" | "High Resolution Audio" | "HQ" | "HR" | "HRA" | "LC" | "Low Complexity" | "MA" | "Master Audio" | ("ES" | "EX" | "Extended Surround" | "HE" | "High Efficiency" | "High Quality" | "High Resolution Audio" | "HQ" | "HR" | "HRA" | "LC" | "Low Complexity" | "MA" | "Master Audio")[];
  bonus?: number;
  bonus_title?: string;
  cd?: number;
  cd_count?: number;
  color_depth?: "10-bit" | "12-bit" | "8-bit";
  container?: "3g2" | "3gp" | "3gp2" | "7z" | "ace" | "arj" | "asf" | "avi" | "bmp" | "bz2" | "cb7" | "cbr" | "cbz" | "divx" | "flv" | "gif" | "gz" | "idx" | "iso" | "jpeg" | "jpg" | "m2ts" | "m4v" | "mk2" | "mk3d" | "mka" | "mkv" | "MKV" | "mov" | "mp4" | "mp4a" | "mpeg" | "mpg" | "nfo" | "nzb" | "ogg" | "ogm" | "ogv" | "png" | "qt" | "r00" | "ra" | "ram" | "rar" | "rm" | "srt" | "ssa" | "tar" | "tbn" | "tgz" | "torrent" | "ts" | "vob" | "wav" | "webm" | "webp" | "wma" | "wmv" | "zip" | ("3g2" | "3gp" | "3gp2" | "7z" | "ace" | "arj" | "asf" | "avi" | "bmp" | "bz2" | "cb7" | "cbr" | "cbz" | "divx" | "flv" | "gif" | "gz" | "idx" | "iso" | "jpeg" | "jpg" | "m2ts" | "m4v" | "mk2" | "mk3d" | "mka" | "mkv" | "MKV" | "mov" | "mp4" | "mp4a" | "mpeg" | "mpg" | "nfo" | "nzb" | "ogg" | "ogm" | "ogv" | "png" | "qt" | "r00" | "ra" | "ram" | "rar" | "rm" | "srt" | "ssa" | "tar" | "tbn" | "tgz" | "torrent" | "ts" | "vob" | "wav" | "webm" | "webp" | "wma" | "wmv" | "zip")[];
  country?: string | GuessitLanguage;
  crc32?: string;
  date?: string | Date;
  disc?: number | (number)[];
  edition?: "Alternative Cut" | "CC" | "collector" | "Collector" | "Criterion" | "DC" | "ddc" | "deluxe" | "Deluxe" | "Director's Cut" | "Director's Definitive Cut" | "extended" | "Extended" | "Fan" | "Festival" | "imax" | "IMAX" | "limited" | "Limited" | "Remastered" | "Restored" | "se" | "Special" | "theatrical" | "Theatrical" | "Ultimate" | "Uncensored" | "Uncut" | "Unrated" | ("Alternative Cut" | "CC" | "collector" | "Collector" | "Criterion" | "DC" | "ddc" | "deluxe" | "Deluxe" | "Director's Cut" | "Director's Definitive Cut" | "extended" | "Extended" | "Fan" | "Festival" | "imax" | "IMAX" | "limited" | "Limited" | "Remastered" | "Restored" | "se" | "Special" | "theatrical" | "Theatrical" | "Ultimate" | "Uncensored" | "Uncut" | "Unrated")[];
  episode?: number | (number)[];
  episode_count?: number;
  episode_details?: string | (string)[];
  episode_format?: "Minisode";
  episode_title?: string;
  film?: number;
  film_title?: string;
  frame_rate?: string;
  language?: string | GuessitLanguage | (string | GuessitLanguage)[];
  mimetype?: "application/x-bittorrent" | "application/x-iso9660-image" | "application/x-rar-compressed" | "application/zip" | "image/gif" | "image/jpeg" | "image/png" | "text/plain" | "video/mp2t" | "video/mp4" | "video/webm" | "video/x-matroska" | "video/x-msvideo";
  other?: "2in1" | "3D" | "asrequested" | "Audio Fixed" | "Banner" | "Bonus" | "BT.2020" | "Classic" | "Clear Art" | "Clear Logo" | "Colorized" | "Complet" | "Complete" | "CONVERT" | "Converted" | "Cover" | "Dirfix" | "Disc Art" | "DOCU" | "Documentary" | "DOKU" | "Dolby Vision" | "Dual" | "Dual Audio" | "East Coast Feed" | "Extras" | "Fan Subtitled" | "Fanart" | "Fansub" | "Fast Subtitled" | "Fastsub" | "FHD" | "Fix" | "Fixed" | "Full HD" | "Half Over Under" | "Half Side By Side" | "Hardcoded Subtitles" | "HC" | "HD" | "HDLight" | "HDR10" | "HFR" | "High Frame Rate" | "High Quality" | "High Resolution" | "HQ" | "HR" | "Hybrid" | "Internal" | "Landscape" | "LD" | "LDTV" | "LiNE" | "Line Audio" | "Line Dubbed" | "Logo" | "Low Definition" | "MD" | "mHD" | "Mic Dubbed" | "Micro HD" | "Mux" | "Nfofix" | "NTSC" | "Oad" | "OAR" | "Oav" | "Obfuscated" | "Ona" | "Open Matte" | "Original Animated Video" | "Original Animation DVD" | "Original Aspect Ratio" | "Original Net Animation" | "Original Video" | "OV" | "Ova" | "Over Under" | "PAL" | "postbot" | "Poster" | "Preair" | "Proof" | "Prooffix" | "Proper" | "PS Vita" | "R5" | "RC" | "Read NFO" | "Real" | "Reencoded" | "Region 5" | "Region C" | "Remux" | "Repost" | "Retail" | "Rip" | "Sample" | "Scrambled" | "Screener" | "SDR" | "SECAM" | "Side By Side" | "Standard Dynamic Range" | "Straight to Video" | "STV" | "Sync Fixed" | "Thumbnail" | "Trailer" | "UHD" | "Ultra HD" | "Upscaled" | "Variable Frame Rate" | "VFR" | "Virtual Reality" | "Vita" | "VO" | "vost" | "West Coast Feed" | "Widescreen" | "ws" | "xpost" | "XXX" | ("2in1" | "3D" | "asrequested" | "Audio Fixed" | "Banner" | "Bonus" | "BT.2020" | "Classic" | "Clear Art" | "Clear Logo" | "Colorized" | "Complet" | "Complete" | "CONVERT" | "Converted" | "Cover" | "Dirfix" | "Disc Art" | "DOCU" | "Documentary" | "DOKU" | "Dolby Vision" | "Dual" | "Dual Audio" | "East Coast Feed" | "Extras" | "Fan Subtitled" | "Fanart" | "Fansub" | "Fast Subtitled" | "Fastsub" | "FHD" | "Fix" | "Fixed" | "Full HD" | "Half Over Under" | "Half Side By Side" | "Hardcoded Subtitles" | "HC" | "HD" | "HDLight" | "HDR10" | "HFR" | "High Frame Rate" | "High Quality" | "High Resolution" | "HQ" | "HR" | "Hybrid" | "Internal" | "Landscape" | "LD" | "LDTV" | "LiNE" | "Line Audio" | "Line Dubbed" | "Logo" | "Low Definition" | "MD" | "mHD" | "Mic Dubbed" | "Micro HD" | "Mux" | "Nfofix" | "NTSC" | "Oad" | "OAR" | "Oav" | "Obfuscated" | "Ona" | "Open Matte" | "Original Animated Video" | "Original Animation DVD" | "Original Aspect Ratio" | "Original Net Animation" | "Original Video" | "OV" | "Ova" | "Over Under" | "PAL" | "postbot" | "Poster" | "Preair" | "Proof" | "Prooffix" | "Proper" | "PS Vita" | "R5" | "RC" | "Read NFO" | "Real" | "Reencoded" | "Region 5" | "Region C" | "Remux" | "Repost" | "Retail" | "Rip" | "Sample" | "Scrambled" | "Screener" | "SDR" | "SECAM" | "Side By Side" | "Standard Dynamic Range" | "Straight to Video" | "STV" | "Sync Fixed" | "Thumbnail" | "Trailer" | "UHD" | "Ultra HD" | "Upscaled" | "Variable Frame Rate" | "VFR" | "Virtual Reality" | "Vita" | "VO" | "vost" | "West Coast Feed" | "Widescreen" | "ws" | "xpost" | "XXX")[];
  part?: number | (number)[];
  proper_count?: number;
  release_group?: string;
  screen_size?: "1080i" | "1080p" | "1440p" | "1444x866" | "2160p" | "360p" | "368p" | "480p" | "4k" | "540p" | "576p" | "720p" | "720x432" | "960x544";
  season?: number | (number)[];
  season_count?: number;
  size?: string;
  source?: "Analog HDTV" | "Blu-ray" | "Camera" | "Digital Master" | "Digital TV" | "DVD" | "HD Camera" | "HD Telecine" | "HD Telesync" | "HD-DVD" | "HDTV" | "Laserdisc" | "Pay-per-view" | "Satellite" | "Telecine" | "Telesync" | "TV" | "Ultra HD Blu-ray" | "Ultra HDTV" | "VHS" | "Video on Demand" | "Web" | "Workprint";
  streaming_service?: "4OD" | "9Now" | "9NOW" | "A&E" | "ABC" | "ABC Australia" | "Adult Swim" | "AE" | "AJAZ" | "Al Jazeera English" | "ALL4" | "Amazon" | "Amazon Prime" | "AMBC" | "AMC" | "America's Test Kitchen" | "AMZN" | "AMZN-CBR" | "Animal Planet" | "AnimeLab" | "ANLB" | "ANPL" | "AOL" | "AppleTV" | "APTV" | "ARD" | "AS" | "ATK" | "ATV+" | "ATVP" | "AUBC" | "BBC iPlayer" | "Binge" | "BKPL" | "Blackpills" | "BLU" | "BluTV" | "BNGE" | "BOOM" | "Boomerang" | "BRAV" | "BravoTV" | "Canal+" | "Cartoon Network" | "CBC" | "CBS" | "CC" | "CCGC" | "Channel 4" | "CHGD" | "CHRGD" | "Cinemax" | "CMAX" | "CMT" | "CN" | "CNBC" | "CNLP" | "Comedians in Cars Getting Coffee" | "Comedy Central" | "Country Music Television" | "CR" | "Crackle" | "CRAV" | "Crave" | "CRKL" | "Crunchy Roll" | "CSpan" | "CSPN" | "CTV" | "CUR" | "CuriosityStream" | "CW" | "CWS" | "CWSeed" | "Daisuki" | "DC Universe" | "DCU" | "DDY" | "Deadhouse Films" | "DF" | "DHF" | "Digiturk Diledigin Yerde" | "DISC" | "Discovery" | "Discovery Plus" | "Disney" | "Disney+" | "DIY" | "DIY Network" | "Doc Club" | "DOCC" | "DPlay" | "DPLY" | "DramaFever" | "DSCP" | "DSKI" | "DSNP" | "DSNY" | "E!" | "El Trece" | "ePix" | "EPIX" | "ESPN" | "ESQ" | "Esquire" | "ETTV" | "ETV" | "Facebook Watch" | "FAM" | "Family" | "Family Jr" | "Fandor" | "FANDOR" | "FBWatch" | "FJR" | "FOOD" | "Food Network" | "Fox" | "FOX" | "Fox Premium" | "FOXP" | "Foxtel" | "FP" | "FREE" | "Freeform" | "FXTL" | "FYI" | "FYI Network" | "Gaga" | "GagaOOLala" | "GC" | "GLBL" | "GLOB" | "Global" | "GloboSat Play" | "Hallmark" | "HBO" | "HBO Go" | "HBO Max" | "HGTV" | "HIST" | "History" | "HLMK" | "HMAX" | "hoichoi" | "HoiChoi" | "Hulu" | "HULU" | "ID" | "IFC" | "iflix" | "IFX" | "INA" | "Investigation Discovery" | "iP" | "iQIYI" | "iT" | "iTunes" | "ITV" | "KNOW" | "Knowledge Network" | "LIFE" | "Lifetime" | "MBC" | "MBCVOD" | "MNBC" | "Motor Trend OnDemand" | "MSNBC" | "MTOD" | "MTV" | "MUBI" | "NATG" | "National Audiovisual Institute" | "National Film Board" | "National Geographic" | "NBA" | "NBA TV" | "NBC" | "Netflix" | "NF" | "NFB" | "NFL" | "NFL Now" | "NFLN" | "NHL GameCenter" | "NICK" | "NICKAPP" | "Nickelodeon" | "Norsk Rikskringkasting" | "NRK" | "ODK" | "OnDemandKorea" | "Oprah Winfrey Network" | "Opto" | "OPTO" | "OWN" | "Paramount+" | "ParamountPlus" | "PBS" | "PBS Kids" | "PBSK" | "PCOK" | "Peacock" | "Playstation Network" | "PLUZ" | "Pluzz" | "PMNP" | "PMT+" | "PMTP" | "POGO" | "PokerGO" | "PSN" | "Rakuten TV" | "RED" | "RKTN" | "ROKU" | "RTE" | "RTE One" | "RUUTU" | "SBS" | "SCI" | "Science Channel" | "SeeSo" | "SESO" | "SHMI" | "SHO" | "Shomi" | "Showtime" | "SNET" | "Sony" | "SONY" | "SPIK" | "Spike" | "Spike TV" | "SPKE" | "Sportsnet" | "Sprout" | "SPRT" | "Stan" | "STAN" | "Starz" | "STZ" | "Sveriges Television" | "SVT" | "SwearNet" | "SWER" | "Syfy" | "SYFY" | "TBS" | "TFou" | "TFOU" | "The CW" | "The Roku Channel" | "TLC" | "TUBI" | "TubiTV" | "TV Land" | "TV3" | "TV3 Ireland" | "TV4" | "TV4 Sweeden" | "TVING" | "TVL" | "TVNZ" | "UFC" | "UFC Fight Pass" | "UKTV" | "UNIV" | "Univision" | "USA Network" | "USAN" | "Velocity" | "VH1" | "VICE" | "Viceland" | "Viki" | "VIKI" | "Vimeo" | "VLCT" | "VMEO" | "VRV" | "W Network" | "WatchMe" | "WME" | "WNET" | "WWE Network" | "WWEN" | "XBOX" | "Xbox Video" | "Yahoo" | "YHOO" | "YouTube Red" | "ZDF";
  subtitle_language?: string | GuessitLanguage | (string | GuessitLanguage)[];
  title?: string;
  type?: "episode" | "movie";
  uuid?: string;
  version?: number;
  video_api?: "DXVA";
  video_bit_rate?: string;
  video_codec?: "DivX" | "DVDivX" | "H.263" | "H.264" | "H.265" | "MPEG-2" | "RealVideo" | "VC-1" | "VP7" | "VP8" | "VP80" | "VP9" | "Xvid" | "XviD";
  video_profile?: "Advanced Video Codec High Definition" | "Baseline" | "BP" | "EP" | "Extended" | "HEVC" | "High" | "High 10" | "High 4:2:2" | "High 4:4:4 Predictive" | "High Efficiency Video Coding" | "HiP" | "HP" | "Main" | "MP" | "SC" | "Scalable Video Coding" | "SVC" | "XP" | ("Advanced Video Codec High Definition" | "Baseline" | "BP" | "EP" | "Extended" | "HEVC" | "High" | "High 10" | "High 4:2:2" | "High 4:4:4 Predictive" | "High Efficiency Video Coding" | "HiP" | "HP" | "Main" | "MP" | "SC" | "Scalable Video Coding" | "SVC" | "XP")[];
  website?: string;
  year?: number;
  /** Any future / custom property. */
  [key: string]: unknown;
}
